import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\MoveToTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MoveToTrashModelNotificationController.php
* @route '/api/move-to-trash'
*/
const MoveToTrashModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MoveToTrashModelNotificationController.url(options),
    method: 'post',
})

MoveToTrashModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/move-to-trash',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\MoveToTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MoveToTrashModelNotificationController.php
* @route '/api/move-to-trash'
*/
MoveToTrashModelNotificationController.url = (options?: RouteQueryOptions) => {
    return MoveToTrashModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\MoveToTrashModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MoveToTrashModelNotificationController.php
* @route '/api/move-to-trash'
*/
MoveToTrashModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MoveToTrashModelNotificationController.url(options),
    method: 'post',
})

export default MoveToTrashModelNotificationController